// Code shared between the embeddable Search Widget
// (`channels/services/search-widget`) and the Unify dashboard's install page
// (`interfaces/services/unify-dashboard`).
//
// It lives in a library rather than inside the widget service because both
// bugs it prevents came from the two sides keeping their own copies:
//
//   - the attribute defaults drifted on three of four values, and since the
//     install page omits any attribute still at its default, a retailer who
//     customised nothing copied a snippet that rendered differently from the
//     preview they had just been shown;
//   - `normaliseFontStack` existed only in the dashboard, so a retailer who
//     hand-edited the pasted snippet still hit the bare-family fallback to
//     Times that it exists to prevent.
//
// Keep this package free of anything browser- or React-specific: the widget
// bundles it with esbuild for the browser, the dashboard imports it through
// Vite, and the tests run it in plain Node.
const defaults = require('./defaults.json');
const { productUrl, formatPrice, escapeHtml, safeImageUrl, firstImageUrl, normaliseFontStack } = require('./helpers');

module.exports = { defaults, productUrl, formatPrice, escapeHtml, safeImageUrl, firstImageUrl, normaliseFontStack };
